import { instance } from './ApiRequest';
import {
    IMPORT_ONLINE_TRANSACTIONS_DATA,
    GET_ALL_STUDENTS_DATA_FOR_HELP_DESK,
    GET_ALL_CANDIDATES_FROM_DB,
    UPDATE_STUDENT_APPROVAL_REJECT_STATUS
} from 'constants/constants';

let _HelpDeskAdminServices = {
    async ImportOnlineTransactionsData(body) {
        return await instance.post(IMPORT_ONLINE_TRANSACTIONS_DATA, body);
    },

    async GetAllCandidatesForHelpDesk(pageIndex, pageSize, searchTerm) {
        return await instance.get(`${GET_ALL_STUDENTS_DATA_FOR_HELP_DESK}?pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}`);
    },
    async GetAllCandidatesFromDB(pageIndex, pageSize, searchTerm) {
        return await instance.get(`${GET_ALL_CANDIDATES_FROM_DB}?pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}`);
    },
    async SearchCandidatesFromDB(pageIndex, pageSize, searchTerm) {
        return await instance.get(`${GET_ALL_CANDIDATES_FROM_DB}?pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}`);
    },
    async UpdateStudentApprovalRejectStatus(body) {
        return await instance.post(UPDATE_STUDENT_APPROVAL_REJECT_STATUS, body);
    },
}

export default _HelpDeskAdminServices;